import { Space } from 'antd';
import moment from 'moment';
import { useContext, useMemo } from 'react';

import { CLIENTS_FILTER, DATE_FORMATS } from '@app/constants';
import {
  CHF_DATE_END,
  CHF_DATE_START,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import { defineFastDatesFilter } from '@pages/Clients/ClientsList/utils';

import {
  CUSTOM_PERIOD,
  NEXT_N_DAYS,
  PERIODS,
} from '@pages/Clients/ClientsList/constants/periods';

import { DatesTagContainer } from '@pages/Clients/ClientsList/components/Filters/DatesTagContainer';

const filtersArea = CLIENTS_FILTER;

export const ClientsBirthdayLabel = ({
  includedFiltersIndex,
}: {
  includedFiltersIndex: number;
}) => {
  const { memoizedServerFilters } = useContext(ClientFiltersContext);
  const Values =
    memoizedServerFilters.ClientsFilter?.[includedFiltersIndex]?.Values?.[0];
  const DateStart = Values?.DateStart || '';
  const DateEnd = Values?.DateEnd || '';
  const Birthday = Values?.Birthday || null;

  const periodTags = useMemo(() => {
    const period = defineFastDatesFilter({
      startDate: DateStart,
      endDate: DateEnd,
      today: moment().format(DATE_FORMATS.ISO_FORMAT_NO_TIMEZONE),
      isShiftToFeature: true,
    });

    if (period === NEXT_N_DAYS) {
      const calculateNDays = (startDate: string, endDate: string) => {
        const start = moment(startDate);
        const end = moment(endDate);
        return end.diff(start, 'days');
      };

      // Потенциальные баги из-за значений по умолчанию
      const nDays = calculateNDays(DateStart || '', DateEnd || '');

      return (
        <DatesTagContainer
          filtersArea={filtersArea}
          filterGroupIndex={includedFiltersIndex}
          label={`Свой период: ${nDays}`}
          valueKey={CHF_DATE_START}
        />
      );
    } else if (period === CUSTOM_PERIOD && (DateStart || DateEnd)) {
      const handleStartDate = new Date(String(DateStart)).toLocaleDateString();
      const handleEndDate = new Date(String(DateEnd)).toLocaleDateString();

      if (DateStart && DateEnd) {
        return (
          <>
            <DatesTagContainer
              filtersArea={filtersArea}
              filterGroupIndex={includedFiltersIndex}
              label={`c ${handleStartDate}`}
              valueKey={CHF_DATE_START}
            />
            <DatesTagContainer
              filtersArea={filtersArea}
              filterGroupIndex={includedFiltersIndex}
              label={`по ${handleEndDate}`}
              valueKey={CHF_DATE_END}
            />
          </>
        );
      } else if (DateStart && !DateEnd) {
        return (
          <DatesTagContainer
            filtersArea={filtersArea}
            filterGroupIndex={includedFiltersIndex}
            label={`c ${handleStartDate}`}
            valueKey={CHF_DATE_START}
          />
        );
      } else if (!DateStart && DateEnd) {
        return (
          <DatesTagContainer
            filtersArea={filtersArea}
            filterGroupIndex={includedFiltersIndex}
            label={`по ${handleEndDate}`}
            valueKey={CHF_DATE_END}
          />
        );
      }
    } else {
      return (
        <DatesTagContainer
          filtersArea={filtersArea}
          filterGroupIndex={includedFiltersIndex}
          label={PERIODS.find(({ id }) => id === period)?.label}
          valueKey={CHF_DATE_START}
        />
      );
    }
  }, [DateStart, DateEnd, includedFiltersIndex]);

  const hasMinimumOneTag = useMemo(() => {
    if (Birthday === null && (DateStart || DateEnd)) {
      return true;
    } else if (Birthday !== null && !DateStart && !DateEnd) {
      return true;
    } else {
      return false;
    }
  }, [Birthday, DateStart, DateEnd]);

  return (
    <Space
      className={`clients-birthday-label${includedFiltersIndex}`}
      direction="vertical"
    >
      <span>День рождения</span>
      {hasMinimumOneTag && <>{periodTags}</>}
    </Space>
  );
};
